var render = function render(){var _vm=this,_c=_vm._self._c;return _c('source-of-fund-files-table',{model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})
}
var staticRenderFns = []

export { render, staticRenderFns }